// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DqDk","rootNoMargin":"styles_rootNoMargin__2aKSw"};